import { ORGANIZATION_ROLES } from '@hero/constants';

import { useSelectedOrganization } from './useSelectedOrganization';

function useIsAdminOrganization() {
  const organization = useSelectedOrganization();

  const isOrganizationAdmin =
    organization?.role === ORGANIZATION_ROLES.admin ||
    organization?.role === ORGANIZATION_ROLES.owner;

  return isOrganizationAdmin;
}

export { useIsAdminOrganization };
